import { render, staticRenderFns } from "./ContentControlPanel.vue?vue&type=template&id=cb3ff54a&scoped=true"
import script from "./ContentControlPanel.vue?vue&type=script&lang=js"
export * from "./ContentControlPanel.vue?vue&type=script&lang=js"
import style0 from "./ContentControlPanel.vue?vue&type=style&index=0&id=cb3ff54a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb3ff54a",
  null
  
)

export default component.exports